import * as React from 'react';
import ProductCompareClearAll from "../ProductCompareClearAll";
import ProductCompare from "@system/config/product-compare";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useProductStore } from 'src/hooks/product';

const BottomCompareActions = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ model_ProductCompare_data }, {}, {}] = useProductStore();
    return (
        <>

            <div className="col-12 col-md-auto p-0 align-self-center">
                {__check(['PRODUCT_COMPARE_API_CALL', { inline: true }]).render}
                {!__check(['PRODUCT_COMPARE_API_CALL']).status &&
                    <div className="compare-actions">
                        <ProductCompareClearAll/>
                        <a className={"bs5 btn btn-primary " + (Object.entries(model_ProductCompare_data).length <= 1 ? 'disabled' : '')}
                           onClick={(e) => {
                               window.location.href = ProductCompare.getProductComparePageRouteURL();
                           }} href={void (0)}>COMPARE
                            ({Object.entries(model_ProductCompare_data).length}/10)</a>
                    </div>
                }
            </div>

        </>
    );
}

export default BottomCompareActions;